module.exports = __webpack_public_path__ + "img/pay-fail.46db4359.png";